import _extends from '../../../../node_modules/@babel/runtime/helpers/esm/extends.js';
import _defineProperty from '../../../../node_modules/@babel/runtime/helpers/esm/defineProperty.js';
import _objectWithoutProperties from '../../../../node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js';
import React__default from 'react';
import PropTypes__default from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import clsx from 'clsx';
import Chip from '@material-ui/core/Chip';
import Avatar from '@material-ui/core/Avatar';
import Typography from '@material-ui/core/Typography';
import { hexToRgb } from '../../../theme/theme.js';

var _excluded = ["color", "disabled", "clickable", "deleteIcon", "icon", "label", "size", "variant", "onDelete", "className", "onImage", "active", "avatarIcon", "avatarColor", "avatarLongNumber", "avatarNumber", "onClick"];
var useStyles = makeStyles(function (theme) {
  return {
    onImage: {
      background: hexToRgb("#776E62", "0.6"),
      borderRadius: theme.spacing(2.25),
      color: theme.palette.grey["0"],
      height: theme.spacing(3)
    },
    "default": {
      background: theme.palette.secondary["50"],
      height: theme.spacing(3.5),
      color: theme.palette.secondary["900"]
    },
    active: {
      color: theme.palette.secondary["900"],
      background: theme.palette.secondary["100"],
      borderRadius: theme.spacing(1.875),
      height: theme.spacing(3.5)
    },
    avatarOnImageIcon: {
      width: theme.spacing(3.125) + "px !important"
    },
    avatarOnImageNumberLong: {
      width: theme.spacing(4.75) + "px !important"
    },
    avatarOnImageNumber: {
      width: theme.spacing(3.875) + "px !important"
    },
    avatarColorGreen: {
      backgroundColor: theme.palette.primary["500"] + " !important",
      width: theme.spacing(3) + "px !important",
      height: theme.spacing(3) + "px !important"
    },
    avatarColorGrey: {
      backgroundColor: theme.palette.secondary["A700"] + " !important",
      width: theme.spacing(3) + "px !important",
      height: theme.spacing(3) + "px !important"
    },
    avatarNoImageNumber: {
      color: theme.palette.secondary["900"] + " !important",
      background: theme.palette.grey["0"] + " !important",
      border: theme.spacing(0.125) + "px solid " + theme.palette.grey["50"],
      marginLeft: theme.spacing(0.125) + "px !important",
      width: theme.spacing(3.875) + "px !important",
      height: theme.spacing(3.5) + "px !important",
      borderRadius: "50%",
      boxSizing: "border-box"
    },
    avatarOnImage: {
      border: theme.spacing(0.125) + "px solid " + theme.palette.grey["0"],
      marginLeft: -theme.spacing(0.75) + "px !important",
      height: theme.spacing(3) + "px !important",
      borderRadius: theme.spacing(1.5),
      boxSizing: "border-box",
      "& i": {
        color: theme.palette.secondary["900"],
        fontSize: theme.spacing(2)
      }
    },
    avatarOnImageColor: {
      color: theme.palette.secondary["900"] + " !important",
      background: theme.palette.grey["0"] + " !important"
    },
    label: {
      padding: theme.spacing(0.625),
      fontSize: theme.spacing(1.625),
      color: "rgba(0, 0, 0, 0.64)"
    },
    labelOnImage: {
      padding: theme.spacing(0.625, 0.375),
      fontSize: theme.spacing(1.625),
      color: theme.palette.grey["0"]
    },
    clickable: {
      border: theme.spacing(0.125) + "px solid " + theme.palette.secondary["500"],
      boxSizing: "border-box",
      borderRadius: theme.spacing(3.375),
      height: theme.spacing(4.25),
      color: theme.palette.secondary["900"],
      background: theme.palette.grey["0"],
      fontWeight: theme.spacing(62.5),
      fontSize: theme.spacing(1.75)
    },
    image: {
      color: theme.palette.secondary["900"],
      background: theme.palette.grey["0"]
    },
    avatarNumber: {
      fontSize: theme.spacing(1.625),
      fontWeight: theme.spacing(75),
      lineHeight: theme.spacing(2),
      padding: theme.spacing(0.25)
    },
    colorsPrimary: {
      color: theme.palette.primary.main,
      borderColor: theme.palette.primary.main
    },
    colorsSecondary: {
      color: theme.palette.secondary.main,
      borderColor: theme.palette.secondary.main
    }
  };
});
var CustomChip = function CustomChip(_ref) {
  var color = _ref.color,
    disabled = _ref.disabled,
    clickable = _ref.clickable,
    deleteIcon = _ref.deleteIcon,
    icon = _ref.icon,
    label = _ref.label,
    size = _ref.size,
    variant = _ref.variant,
    onDelete = _ref.onDelete,
    className = _ref.className,
    onImage = _ref.onImage,
    active = _ref.active,
    avatarIcon = _ref.avatarIcon,
    avatarColor = _ref.avatarColor,
    avatarLongNumber = _ref.avatarLongNumber,
    avatarNumber = _ref.avatarNumber,
    onClick = _ref.onClick,
    props = _objectWithoutProperties(_ref, _excluded);
  var classes = useStyles();
  var handleDelete = function handleDelete() {
    if (onDelete) {
      onDelete();
    }
  };
  var handleClick = function handleClick() {
    if (onClick) {
      onClick();
    }
  };
  return /*#__PURE__*/React__default.createElement(Chip, _extends({}, props, {
    className: clsx(className, _defineProperty({}, classes.onImage, onImage), _defineProperty({}, classes["default"], !onImage && !clickable), _defineProperty({}, classes.active, !onImage && active), _defineProperty({}, classes.clickable, clickable), _defineProperty({}, classes.colorsPrimary, color === "primary"), _defineProperty({}, classes.colorsSecondary, color === "secondary")),
    color: color,
    disabled: disabled,
    avatar: (avatarIcon || avatarLongNumber || avatarNumber || avatarColor) && /*#__PURE__*/React__default.createElement(Avatar, {
      className: clsx(_defineProperty({}, classes.avatarOnImageIcon, avatarIcon && onImage), _defineProperty({}, classes.avatarOnImage, onImage), _defineProperty({}, classes.avatarOnImageColor, onImage && !avatarColor), _defineProperty({}, classes.avatarOnImageNumberLong, avatarLongNumber && onImage && !avatarColor), _defineProperty({}, classes.avatarNoImageNumber, avatarNumber && !onImage), _defineProperty({}, classes.avatarOnImageNumber, !avatarLongNumber && onImage && !avatarIcon), _defineProperty({}, classes.avatarColorGreen, !avatarLongNumber && !avatarIcon && avatarColor === "green"), _defineProperty({}, classes.avatarColorGrey, !avatarLongNumber && !avatarIcon && avatarColor === "grey"))
    }, avatarIcon ? avatarIcon : /*#__PURE__*/React__default.createElement(Typography, {
      className: classes.avatarNumber,
      variant: "button"
    }, avatarNumber || avatarLongNumber)),
    clickable: clickable,
    deleteIcon: deleteIcon,
    icon: icon,
    label: label && /*#__PURE__*/React__default.createElement(Typography, {
      className: clsx(_defineProperty({}, classes.label, !onImage), _defineProperty({}, classes.labelOnImage, onImage), _defineProperty({}, classes.colorsPrimary, color === "primary"), _defineProperty({}, classes.colorsSecondary, color === "secondary")),
      variant: "button"
    }, label),
    size: size,
    variant: variant,
    onDelete: onDelete ? handleDelete : null,
    onClick: onClick ? handleClick : null
  }));
};
CustomChip.defaultProps = {
  disabled: false,
  onImage: false,
  active: false
};
CustomChip.propTypes = {
  color: PropTypes__default.string,
  disabled: PropTypes__default.bool,
  clickable: PropTypes__default.bool,
  deleteIcon: PropTypes__default.element,
  icon: PropTypes__default.element,
  label: PropTypes__default.node,
  size: PropTypes__default.string,
  variant: PropTypes__default.string,
  className: PropTypes__default.string,
  onDelete: PropTypes__default.func,
  onImage: PropTypes__default.bool,
  active: PropTypes__default.bool,
  avatarIcon: PropTypes__default.any,
  avatarColor: PropTypes__default.oneOf(["green", "grey"]),
  avatarLongNumber: PropTypes__default.number,
  avatarNumber: PropTypes__default.number,
  onClick: PropTypes__default.func
};

export { CustomChip as default };
//# sourceMappingURL=CustomChip.js.map
